import { About } from "./about"
import { TechnicalExpertise } from "./technical-expertise"

export const AboutMe=()=>{
    return(
        <>
            <About/>
            <TechnicalExpertise/>
        </>
    )
}